import { Component, OnInit } from '@angular/core';
import { AppService } from '../../../app.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'navbar-side',
  templateUrl: './navbar-side.component.html',
  styleUrls: ['./navbar-side.component.scss']
})
export class NavbarSideComponent implements OnInit {
    public menuVisible: string;
    public undercarriageUrl: SafeUrl;
    public getUrl: SafeUrl;
    public logouturl: SafeUrl;

    
    public showGet: boolean = false;
    public showUndercarriage: boolean = false;

    public formadmin:SafeUrl;
    public formsearch:SafeUrl
    public showDigitalForm:boolean=false;
    constructor(private _appService: AppService, private _sanitizer: DomSanitizer,
        private _route: ActivatedRoute, private _router: Router,) { }

    ngOnInit() {
        this._appService.getMenuVisible().subscribe(result => {
            if (result)
                this.menuVisible = 'show-menu';
            else
                this.menuVisible = '';
        });

        this._appService.getUndercarriageUrl().subscribe(result => {
            if (result != null && result != '')
                this.showUndercarriage = true;
            this.undercarriageUrl = this._sanitizer.bypassSecurityTrustUrl(result);
            this.formsearch =this._sanitizer.bypassSecurityTrustUrl(result+'digitalForm/search'); //result+'digitalForm/search';
            this.formadmin = this._sanitizer.bypassSecurityTrustUrl(result+'digitalForm/adminsearch');//result+'digitalForm/adminsearch';
            this.logouturl = this._sanitizer.bypassSecurityTrustUrl(result+'account/signout');
        });
        this._appService.getGetUrl().subscribe(result => {
            if (result != null && result != '')
                this.showGet = true;
            this.getUrl = this._sanitizer.bypassSecurityTrustUrl(result);
          //  this.formsearch =this._sanitizer.bypassSecurityTrustUrl(result+'digitalForm/search'); //result+'digitalForm/search';
            //this.formadmin = this._sanitizer.bypassSecurityTrustUrl(result+'digitalForm/adminsearch');//result+'digitalForm/adminsearch';

        });

        

        let values = window.location.href;
        var newvalue =values.split('/administration/')[1];
        console.log("newvalue_+++++__",newvalue)
        if(newvalue!=undefined && newvalue!="" && newvalue.length>0){
            this.showDigitalForm=true;
        }
    }
}
